export const couponsAdapter = module => {
  module.moduleName = 'coupons'
  return module
}
